/*****************************************************************************/
/*  File Name: tipCountHeader.js                                             */
/*  Date:      June 28, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This bar is a basic title bar that will also have the tip
/*             count in it and the time range
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

//import styles from './styles/roi.module.scss';
import { Grid } from '@mui/material';
import { useROIContext } from '../../context/roiContext';
import * as TIMERANGE from '../../constants/timeRanges';
import styles from './styles/roi.module.scss';
//import * as MODE from '../../constants/modes';

function ConsumerTipCountHeader({ t }) {
  //Load all of the default component varaibles

  //const [timeSet, setTimeSet] = useState('');
  const { selectedTimeRange, roiGrowthTipCount } = useROIContext();
  /* 
  useEffect(() => {
    if (selectedTimeRange === TIMERANGE.weekly) {
      setTimeSet('Week');
    } else if (selectedTimeRange === TIMERANGE.monthly) {
      setTimeSet('Month');
    } else {
      setTimeSet('Week');
    }

    return () => {};
  }, [selectedTimeRange]); */

  return (
    <Grid item xs={12} container className={`${styles.tipCountHeader} ${styles.consumerHeader}`}>
      Potential Cumulative PURE Tier Progress Based on {roiGrowthTipCount} Treatments Per {selectedTimeRange === TIMERANGE.weekly ? 'Week' : 'Month'}
    </Grid>
  );
}

export default withTranslation()(ConsumerTipCountHeader);
